<script setup lang="ts">
// The "Ask Orpheus: <question>" entry point a host renders next to one record.
import { useI18n } from '@/shared/i18n'
import { Icon } from '@/shared/ui'

defineProps<{ question: string }>()
defineEmits<{ ask: [] }>()

const { t } = useI18n()
</script>

<template>
  <button
    type="button"
    class="feature-chat-launcher flex items-center justify-between gap-sm w-full p-sm border border-orpheus rounded-md bg-orpheus-soft text-orpheus cursor-pointer [font:inherit] text-start hover:bg-[var(--ui-color-orpheus-soft-hover)]"
    data-testid="feature-chat-launcher"
    @click="$emit('ask')"
  >
    <span class="feature-chat-launcher__label flex items-center gap-xs min-w-0">
      <Icon name="sparkle" :size="16" aria-hidden="true" />
      <span
        class="feature-chat-launcher__question overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium"
      >
        {{ t('orpheus.featureChat.launcher', { question }) }}
      </span>
    </span>
    <span
      class="feature-chat-launcher__action flex items-center gap-xs min-w-0 shrink-0 font-semibold text-sm"
    >
      {{ t('orpheus.featureChat.launcherAction') }}
      <Icon name="arrow-right" :size="12" aria-hidden="true" />
    </span>
  </button>
</template>
